var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import Tooltip from '@mui/material/Tooltip';
import { OGButton } from '@opengear/buttons';
import { OGTagIcon } from '@opengear/icons/generic/tag';
export function NewTagButton(_a) {
    var toolTipLabel = _a.toolTipLabel, tabIndex = _a.tabIndex, props = __rest(_a, ["toolTipLabel", "tabIndex"]);
    return (_jsx(Tooltip, __assign({ arrow: true, placement: "right", title: toolTipLabel }, { children: _jsx(OGButton, __assign({ "aria-label": toolTipLabel, sx: { minHeight: 'auto', minWidth: 'auto', paddingY: 0.5, paddingX: 0.8 }, variant: "borderless", propagateSpacebar: false }, props, { tabIndex: tabIndex }, { children: _jsx(OGTagIcon, { fontSize: "small" }) })) })));
}
